import { guestQuoteLinkParamsSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import { SitePageShell } from '@/shared/ui';
import { GuestQuoteLinkView } from '@/widgets/guest-quote-link-view';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/**
 * 견적 링크 페이지(`/q/:quoteRequestId/:signature`, 결정 G8·G9) — 공개 라우트. 주소를 해석해 링크 화면에 넘긴다.
 * 서명은 DB 의 소문자 견적 id 로 만들므로 id 는 소문자로 맞춘다. 형식이 틀리면 null 이다.
 * 인쇄 때는 견적서만 남도록 헤더·푸터를 숨긴다.
 */
export const GuestQuoteLinkPage = (): ReactElement => {
  const { quoteRequestId = '', signature = '' } = useParams();
  const parsed = guestQuoteLinkParamsSchema.safeParse({
    quoteRequestId: quoteRequestId.toLowerCase(),
    signature,
  });

  return (
    <SitePageShell
      header={
        <div className="print:hidden">
          <SiteHeader />
        </div>
      }
      footer={
        <div className="print:hidden">
          <SiteFooter />
        </div>
      }
      className="pt-10 sm:pt-12 print:p-0"
    >
      <GuestQuoteLinkView params={parsed.success ? parsed.data : null} />
    </SitePageShell>
  );
};
